// ---------------------------------------------------------------------------
// BrandMark — the YouAreYou "U" logomark (2026 rose refresh).
// A chunky letter-U in rose, with a lighter offset layer behind it for a soft,
// tactile, stacked-paper depth. Use wherever a standalone logomark is needed.
// ---------------------------------------------------------------------------

interface BrandMarkProps {
  className?: string;
}

export default function BrandMark({ className = "h-8 w-8" }: BrandMarkProps) {
  // A single U path, stroked thick with flat tops + a round bottom.
  const U = "M21 10 V40 a15 15 0 0 0 30 0 V10";
  return (
    <svg
      className={className}
      viewBox="0 0 72 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* back layer — lighter pink, offset down-left for depth */}
      <path
        d={U}
        transform="translate(-4 6)"
        stroke="#F5C6D7"
        strokeWidth="16"
        strokeLinecap="butt"
        fill="none"
      />
      {/* front layer — rose */}
      <path
        d={U}
        stroke="#E87CA0"
        strokeWidth="16"
        strokeLinecap="butt"
        fill="none"
      />
    </svg>
  );
}
